// extracted by mini-css-extract-plugin
module.exports = {"superElipse":"super-ellipse-skins-smallOnConfined-superElipse-7c5cfa98","strokeWidth":"super-ellipse-skins-smallOnConfined-strokeWidth-7730c3b4"};